const postSaleActions = {
  FETCH_CARDS_REQUEST: 'POSTSALE_FETCH_CARDS_REQUEST',
  FETCHING_CARDS: 'POSTSALE_FETCHING_CARDS',
  FETCH_CARDS_SUCCESS: 'POSTSALE_FETCH_CARDS_SUCCESS',
  FETCH_CARDS_ERROR: 'POSTSALE_FETCH_CARDS_ERROR',

  SAVE_CARD_REQUEST: 'POSTSALE_SAVE_CARD_REQUEST',
  SAVING_CARD: 'POSTSALE_SAVING_CARD',
  SAVE_CARD_SUCCESS: 'POSTSALE_SAVE_CARD_SUCCESS',
  SAVE_CARD_ERROR: 'POSTSALE_SAVE_CARD_ERROR',

  UPDATE_CARD_STAGE_REQUEST: 'POSTSALE_UPDATE_CARD_STAGE_REQUEST',
  UPDATE_CARD_STAGE_SUCCESS: 'POSTSALE_UPDATE_CARD_STAGE_SUCCESS',
  UPDATE_CARD_STAGE_ERROR: 'POSTSALE_UPDATE_CARD_STAGE_ERROR',

  UPDATE_MIGRATION_STAGE_REQUEST: 'POSTSALE_UPDATE_MIGRATION_STAGE_REQUEST',
  UPDATE_MIGRATION_STAGE_SUCCESS: 'POSTSALE_UPDATE_MIGRATION_STAGE_SUCCESS',
  UPDATE_MIGRATION_STAGE_ERROR: 'POSTSALE_UPDATE_MIGRATION_STAGE_ERROR',

  REORDER_CARDS_REQUEST: 'POSTSALE_REORDER_CARDS_REQUEST',
  REORDER_CARDS_SUCCESS: 'POSTSALE_REORDER_CARDS_SUCCESS',
  REORDER_CARDS_ERROR: 'POSTSALE_REORDER_CARDS_ERROR',

  DELETE_CARD_REQUEST: 'POSTSALE_DELETE_CARD_REQUEST',
  DELETE_CARD_SUCCESS: 'POSTSALE_DELETE_CARD_SUCCESS',
  DELETE_CARD_ERROR: 'POSTSALE_DELETE_CARD_ERROR',

  CREATE_ACCOUNT_REQUEST: 'POSTSALE_CREATE_ACCOUNT_REQUEST',
  CREATING_ACCOUNT: 'POSTSALE_CREATING_ACCOUNT',
  CREATE_ACCOUNT_SUCCESS: 'POSTSALE_CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_ERROR: 'POSTSALE_CREATE_ACCOUNT_ERROR',

  MARK_WELCOME_SENT_REQUEST: 'POSTSALE_MARK_WELCOME_SENT_REQUEST',

  SEND_WELCOME_EMAIL_REQUEST: 'POSTSALE_SEND_WELCOME_EMAIL_REQUEST',
  SENDING_WELCOME_EMAIL: 'POSTSALE_SENDING_WELCOME_EMAIL',
  SEND_WELCOME_EMAIL_SUCCESS: 'POSTSALE_SEND_WELCOME_EMAIL_SUCCESS',
  SEND_WELCOME_EMAIL_ERROR: 'POSTSALE_SEND_WELCOME_EMAIL_ERROR',

  FETCH_COMMENTS_REQUEST: 'POSTSALE_FETCH_COMMENTS_REQUEST',
  FETCHING_COMMENTS: 'POSTSALE_FETCHING_COMMENTS',
  FETCH_COMMENTS_SUCCESS: 'POSTSALE_FETCH_COMMENTS_SUCCESS',
  FETCH_COMMENTS_ERROR: 'POSTSALE_FETCH_COMMENTS_ERROR',

  SAVE_COMMENT_REQUEST: 'POSTSALE_SAVE_COMMENT_REQUEST',
  SAVING_COMMENT: 'POSTSALE_SAVING_COMMENT',
  SAVE_COMMENT_SUCCESS: 'POSTSALE_SAVE_COMMENT_SUCCESS',
  SAVE_COMMENT_ERROR: 'POSTSALE_SAVE_COMMENT_ERROR',

  DELETE_COMMENT_REQUEST: 'POSTSALE_DELETE_COMMENT_REQUEST',

  START_MENTIONS_LISTENER: 'POSTSALE_START_MENTIONS_LISTENER',
  MENTION_RECEIVED: 'POSTSALE_MENTION_RECEIVED',
  DISMISS_MENTION_REQUEST: 'POSTSALE_DISMISS_MENTION_REQUEST',

  FETCH_LOGS_REQUEST: 'POSTSALE_FETCH_LOGS_REQUEST',
  FETCHING_LOGS: 'POSTSALE_FETCHING_LOGS',
  FETCH_LOGS_SUCCESS: 'POSTSALE_FETCH_LOGS_SUCCESS',
  FETCH_LOGS_ERROR: 'POSTSALE_FETCH_LOGS_ERROR',

  SET_CURRENT_CARD: 'POSTSALE_SET_CURRENT_CARD',
  CLEAR_CURRENT_CARD: 'POSTSALE_CLEAR_CURRENT_CARD',

  fetchCards: () => ({
    type: postSaleActions.FETCH_CARDS_REQUEST,
  }),
  saveCard: (card) => ({
    type: postSaleActions.SAVE_CARD_REQUEST,
    payload: card,
  }),
  updateCardStage: (cardId, stage) => ({
    type: postSaleActions.UPDATE_CARD_STAGE_REQUEST,
    payload: { cardId, stage },
  }),
  updateMigrationStage: (cardId, migrationStage) => ({
    type: postSaleActions.UPDATE_MIGRATION_STAGE_REQUEST,
    payload: { cardId, migrationStage },
  }),
  reorderCards: (orderedIds, field = 'sortOrder') => ({
    type: postSaleActions.REORDER_CARDS_REQUEST,
    payload: { orderedIds, field },
  }),
  deleteCard: (cardId) => ({
    type: postSaleActions.DELETE_CARD_REQUEST,
    payload: cardId,
  }),
  createAccount: ({
    cardId, firstName, lastName, email, password, maxCustomHealthProfessionals,
  }) => ({
    type: postSaleActions.CREATE_ACCOUNT_REQUEST,
    payload: {
      cardId, firstName, lastName, email, password, maxCustomHealthProfessionals,
    },
  }),
  markWelcomeSent: (cardId, channel) => ({
    type: postSaleActions.MARK_WELCOME_SENT_REQUEST,
    payload: { cardId, channel },
  }),
  sendWelcomeEmail: (card) => ({
    type: postSaleActions.SEND_WELCOME_EMAIL_REQUEST,
    payload: card,
  }),
  fetchComments: (cardId) => ({
    type: postSaleActions.FETCH_COMMENTS_REQUEST,
    payload: cardId,
  }),
  saveComment: (comment) => ({
    type: postSaleActions.SAVE_COMMENT_REQUEST,
    payload: comment,
  }),
  deleteComment: (commentId, cardId) => ({
    type: postSaleActions.DELETE_COMMENT_REQUEST,
    payload: { commentId, cardId },
  }),
  startMentionsListener: () => ({
    type: postSaleActions.START_MENTIONS_LISTENER,
  }),
  dismissMention: (mentionId) => ({
    type: postSaleActions.DISMISS_MENTION_REQUEST,
    payload: mentionId,
  }),
  fetchLogs: (cardId) => ({
    type: postSaleActions.FETCH_LOGS_REQUEST,
    payload: cardId,
  }),
  setCurrentCard: (card) => ({
    type: postSaleActions.SET_CURRENT_CARD,
    payload: card,
  }),
  clearCurrentCard: () => ({
    type: postSaleActions.CLEAR_CURRENT_CARD,
  }),
};

export default postSaleActions;
